export default __webpack_public_path__ + "static/media/odoo-negative.0f50e48a.svg";